import { BaseCommand } from '@/types/BaseCommand';
import { Example } from '@/types/Example';
import { Flag } from '@/types/Flag';
import { useEffect } from 'react';
import { setBaseCommands, setExamples, setFlags } from 'utils/useZStore';

export const usePopulateStore = (
  examples: Example[],
  commands: BaseCommand[],
  flags: Flag[],
) => {
  useEffect(() => {
    setExamples(examples);
    setBaseCommands(commands);
    setFlags(flags);
  }, [examples, commands, flags]);
};
